// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__lQPkg","title":"header_title__3XcAj","selected":"header_selected__NFi_K"};